// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"f153d77e","226":"4f679667","253":"f329dab0","850":"d52d59de","866":"274e4f5d"}[chunkId] + ".chunk.css";
};